// W11-1 — WHO IS A REAL PERSON. Owner order, 2026-07-31.
//
// HER RULING: the members page shows REAL PEOPLE ONLY, **STRUCTURALLY, NOT BY CLEANUP.** Eighty-odd
// harness accounts had accumulated in the members list from a year of verification runs, and the
// answer she rejected in advance is the obvious one — go and delete them. Deleting is a thing that
// has to be done again after every run, by someone who remembers to, and the evidence a run leaves
// behind is sometimes the point of the run. So they are MARKED, and the list simply does not show
// what is marked.
//
// TWO DOORS INTO THE FLAG, and her order names both:
//   1. THE CONVENTION — a reserved-for-testing address (RFC 2606 / RFC 6761: `.invalid`, `.test`,
//      `.localhost`, `.local`, `example.com`, `example.org`, `example.net`). These domains cannot
//      belong to a real person; that is what reserving them is for.
//   2. THE EXPLICIT FLAG — a harness that says so at creation, for an address the convention cannot
//      see. This is the door that matters going forward: a convention alone is a guess about a
//      string, and a harness that knows what it is should say what it is.
//
// A FLAG IS NOT A DELETE, AND THAT IS THE POINT. The row stays, its evidence stays, its self-cleaning
// stays the law for new runs. It is backstage, behind one owner-only toggle.
//
// PURE. Imports nothing, shared by the server and the dashboard, RUN by `scripts/w11-harness.mjs`.

// The reserved domains and suffixes. Kept as data rather than one regex so the fixture can name
// which rule caught which address when she reads the backfill list.
export const HARNESS_DOMAIN_SUFFIXES = [
  ".invalid", ".test", ".localhost", ".local", ".example",
];
export const HARNESS_DOMAINS = [
  "example.com", "example.org", "example.net", "test.com", "localhost",
];

export function harnessReason(email) {
  const value = String(email || "").trim().toLowerCase();
  if (!value || !value.includes("@")) return "";
  const domain = value.slice(value.lastIndexOf("@") + 1);
  if (!domain) return "";
  if (HARNESS_DOMAINS.includes(domain)) return `reserved domain (${domain})`;
  const suffix = HARNESS_DOMAIN_SUFFIXES.find((s) => domain.endsWith(s));
  if (suffix) return `reserved suffix (${suffix})`;
  return "";
}

// The convention half. False for every address a real member could actually hold — including the
// ones that merely LOOK like tests. `walk@12thhouse.ai` is on a live domain and answers false here;
// her order sends that class to her eye rather than to a pattern.
export function isHarnessEmail(email) {
  return harnessReason(email) !== "";
}

// THE ONE QUESTION EVERY SURFACE ASKS. Either door opens it: the stored flag a harness set, or the
// convention. The stored flag is checked first so an address the convention cannot see is still
// backstage, and so a flag can never be silently overridden by a pattern that disagrees.
export function isHarnessAccount({ email = "", isHarness = false } = {}) {
  return Boolean(isHarness) || isHarnessEmail(email);
}

// The owner-only toggle's label and the sentence under a revealed list. One string, so the button
// and the state it produces cannot describe different things.
export const HARNESS_TOGGLE_SHOW = "Show test accounts";
export const HARNESS_TOGGLE_HIDE = "Hide test accounts";
export function harnessHiddenNote(count) {
  const n = Number(count) || 0;
  if (n <= 0) return "";
  return `${n} test ${n === 1 ? "account is" : "accounts are"} hidden. They are harness rows, not people.`;
}
